export interface Session {
  id: string;
  clientName: string;
  date: string;
  time: string;
  duration: number;
  status: 'scheduled' | 'completed' | 'cancelled';
  type: '1-on-1' | 'group' | 'review';
  earnings: number;
}

export interface Review {
  id: string;
  clientName: string;
  rating: number;
  comment: string;
  date: string;
  sessionType: string;
}

export interface Earnings {
  thisMonth: number;
  lastMonth: number;
  totalEarnings: number;
  pendingPayout: number;
  sessionCount: number;
  averageRating: number;
}

export const exampleSessions: Session[] = [
  {
    id: '1',
    clientName: 'John Smith',
    date: '2025-01-20',
    time: '10:00 AM',
    duration: 60,
    status: 'scheduled',
    type: '1-on-1',
    earnings: 150
  },
  {
    id: '2',
    clientName: 'Maria Garcia',
    date: '2025-01-19',
    time: '2:00 PM',
    duration: 45,
    status: 'completed',
    type: 'review',
    earnings: 112.50
  },
  {
    id: '3',
    clientName: 'Diabetes Support Group',
    date: '2025-01-18',
    time: '6:00 PM',
    duration: 90,
    status: 'completed',
    type: 'group',
    earnings: 225
  }
];

export const exampleReviews: Review[] = [
  {
    id: '1',
    clientName: 'Maria Garcia',
    rating: 5,
    comment: 'Dr. Chen was incredibly helpful with my diabetes management. Her personalized approach made all the difference.',
    date: '2025-01-19',
    sessionType: 'Review Session'
  },
  {
    id: '2',
    clientName: 'David Wilson',
    rating: 5,
    comment: 'Excellent consultation. Dr. Chen explained everything clearly and provided actionable advice.',
    date: '2025-01-17',
    sessionType: '1-on-1 Session'
  }
];

export const exampleEarnings: Earnings = {
  thisMonth: 2847.50,
  lastMonth: 3120.00,
  totalEarnings: 45680.00,
  pendingPayout: 2847.50,
  sessionCount: 19,
  averageRating: 4.9
}; 